import { SxProps, styled } from '@mui/material'
import { useTopBarHeight } from 'app/menu/components/TopBar/hooks/use-top-bar-height'

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar
}))

// DrawerHeaderContainer exists to apply spacing for the top bar where the fixed element should sit.
export const DrawerHeaderContainer: React.FC<{ sx?: SxProps }> = ({ children, ...rest }) => {
  const topBarHeight = useTopBarHeight()

  return (
    <DrawerHeader {...rest} sx={{ ...rest?.sx, minHeight: { sm: topBarHeight } }}>
      {children}
    </DrawerHeader>
  )
}

export default DrawerHeaderContainer
